<template>
    <el-dialog
        v-if="showPrintDialog"
        class="configPrintDialog"
        :visible="true"
        top="30px"
        width="450px"
        :show-close="false"
        title="价签打印"
    >
        <mc-loading :loading="dialogLoading">
            <xx-detail-card
                :column="1"
                :data="prinDetailInfo"
                :title="''"
            />
            <el-form
                ref="printForm"
                :model="printForm"
                :rules="printFormRules"
                label-position="top"
            >
                <el-form-item
                    prop="printer"
                    label="打印机:"
                >
                    <el-select
                        v-model="printForm.printer"
                        placeholder="请选择打印机"
                    >
                        <el-option
                            v-for="item in printerList"
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                    <xx-link @click="handleClickDownloadPrintHelper">
                        点击下载打印助手
                    </xx-link>
                </el-form-item>
                <el-form-item
                    prop="printQuantity"
                    label="打印数量:"
                >
                    <el-input
                        v-model="printForm.printQuantity"
                        placeholder="请输入打印数量"
                    />
                </el-form-item>
                <el-form-item
                    v-if="isShowProduceArea"
                    prop="produceAreaName"
                    label="产地:"
                >
                    <el-select
                        v-model="printForm.produceAreaName"
                        placeholder="请选择产地"
                        filterable
                        :multiple="false"
                    >
                        <el-option
                            v-for="item in originPlaceList"
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="printDate"
                    label="选择日期:"
                >
                    <template slot="label">
                        <span>请核实日期:</span>
                        <span
                            class="red"
                        >(默认等于采购日期，如有疑问请联系采购负责人)</span>
                    </template>
                    <el-date-picker
                        v-model="printForm.printDate"
                        style="width: 100%;"
                        type="date"
                        placeholder="选择日期"
                        value-format="timestamp"
                        :disabled="isLimitPrintDate"
                    />
                </el-form-item>
                <el-form-item
                    v-if="showHourSelect"
                    prop="printTime"
                    label="选择时间:"
                >
                    <el-select
                        v-model="printForm.printTime"
                        placeholder="请选择时间"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in beforePrintData.expiryTimeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                    <mc-announcement
                        v-if="beforePrintData.alertMessage"
                        :title="beforePrintData.alertMessage"
                        type="warning"
                        show-icon
                        style="margin-top: 10px;"
                    />
                    <!-- 效期类型对应的提示文案 -->
                    <mc-announcement
                        v-for="(item, index) in beforePrintData.tips"
                        :key="index"
                        :title="item"
                        type="warning"
                        show-icon
                        style="margin-top: 10px;"
                    />
                </el-form-item>
                <template v-if="isABSelect && isABOrders">
                    <el-form-item
                        prop="chainTagId"
                        label="请选择A/B单"
                    >
                        <el-popover
                            trigger="hover"
                            placement="top"
                            :content="perHalfDayTips"
                            :disabled="!perHalfDayTips"
                        >
                            <slot slot="reference">
                                <el-select
                                    v-model="printForm.chainTagId"
                                    placeholder="请选择A/B单"
                                    style="width: 100%;"
                                    :disabled="isDisChainTagId"
                                >
                                    <el-option
                                        v-for="item in ABOrdersList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </slot>
                        </el-popover>
                        <mc-announcement
                            title="A单上市日期=所选日期+1；B单上市日期=所选日期+0；预采打印请准确判断AB单，否则会有拒收风险"
                            type="warning"
                            show-icon
                            style="margin-top: 10px;"
                        />
                    </el-form-item>
                </template>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    :disabled="printDisabled"
                    @click="confimPrintByMtob"
                >
                    确认打印
                </el-button>
                <el-button @click="onClickCancelDialog">
                    取消
                </el-button>
            </div>
        </mc-loading>
    </el-dialog>
</template>
<script>
import Rules from '@lsfe/rules';
import moment from 'moment';
import {
    MTOBClient,
    MTOBPrinter,
    ESDKEvents,
    ESDKStatus,
} from '@mtfe/mtob-client';
import { search, cookie, isEmptyValue } from '@lsfe/tools';
import { TEMPLATE_SOURCE_ENUM } from 'utils/enum/print';
import { ExpirationTypeEnum } from './constants';
import { PLAN_TYPE } from '../../constants';
import { getVssPrintBeforeData, getVssPrintData, checkAndQueryProductOrigin } from '../../api';

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        prinDetailInfo: {
            type: Array,
            default: () => [],
        },
        currentRow: {
            type: Object,
            default: () => ({}),
        },
        //  计划类型 0：T0/今日预采  1：T1/明日预采
        planType: {
            type: [String, Number],
            default: '',
        },
        isABSelect: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        const { printer } = search();
        return {
            isABOrders: false,
            ABOrdersList: [
                { label: 'A单：上市日期=所选日期+1', value: 1 },
                { label: 'B单：上市日期=所选日期+0', value: 2 },
            ],
            printerList: [],
            showPrintDialog: false,
            printFormRules: {
                chainTagId: [Rules.isRequired('请选择A/B单')],
                printer: [Rules.isRequired('请选择打印机')],
                printQuantity: [
                    Rules.isRequired('请输入数量'),
                    Rules.typeValid({ type: 'integer' }, '请填整数'),
                    {
                        validator: (rule, value, callback) => {
                            const max = 100;
                            if (value < 1 || value > max) {
                                callback(new Error(`范围1-${max}`));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change',
                    },
                ],
                printDate: [Rules.isRequired('请选择日期')],
                printTime: [Rules.isRequired('请选择时间')],
                produceAreaName: [Rules.isRequired('请选择产地').condition(() => this.isShowProduceArea)],
            },
            printForm: {
                printer: printer || '',
                printQuantity: '',
                printDate: '',
                printTime: '',
                chainTagId: '',
                produceAreaName: '',
            },
            isLimitPrintDate: false,
            supplierId: -1,
            beforePrintData: {
                tips: [],
                expiryTimeList: [],
                alertMessage: '',
                expiryType: '',
            },
            printLogoMap: {},
            isDisChainTagId: false,
            originPlaceList: [],
            isShowProduceArea: false,
            queryOriginPlaceStatus: false, // 查询产地状态，全国产地查询时，接口可能会超时，需要拦截提交
            dialogLoading: false,
        };
    },

    computed: {
        showHourSelect() {
            return (
                this.beforePrintData.expiryTimeList
                && this.beforePrintData.expiryTimeList.length
            );
        },
        printDisabled() {
            if (this.showHourSelect) {
                return !(
                    this.printForm.printer
                    && this.printForm.printQuantity
                    && +this.printForm.printQuantity > 0
                    && this.printForm.printDate
                    && this.printForm.printTime
                );
            } else {
                return !(
                    this.printForm.printer
                    && this.printForm.printQuantity
                    && +this.printForm.printQuantity > 0
                );
            }
        },
        alertMessageValue() {
            return (
                this.beforePrintData.alertMessage
            );
        },
        // 半天批次
        isHalfDay() {
            const { expiryType } = this.beforePrintData;
            const { HALF_DAY } = ExpirationTypeEnum;
            const { code } = HALF_DAY || {};
            return expiryType === code;
        },
        // 预采单半天批次提示
        perHalfDayTips() {
            if (!this.isHalfDay) return '';
            const { printTime } = this.printForm;
            if (printTime === '12:00') {
                return 'A单商品只能打印12点标签，不可选择0点';
            }
            if (printTime === '00:00') {
                return 'B单商品只能打0点标签，不可选择12点';
            }
            return '';
        },
    },

    watch: {
        showDialog: {
            handler(val) {
                if (val) {
                    this.initPrintForm();
                    this.initPrinter();
                }
            },
            immediate: true,
        },
        'printForm.printTime': {
            handler(newV) {
                if (!this.isHalfDay) return;
                // 配置映射：时间 -> 对应的 chainTagId
                const timeToTagMap = {
                    '12:00': 1, // A单
                    '00:00': 2, // B单
                };
                const targetTagId = timeToTagMap[newV];
                // 只有匹配到配置时才执行赋值
                if (targetTagId !== undefined) {
                    this.printForm.chainTagId = targetTagId;
                    this.isDisChainTagId = true;
                }
            },
        },
    },

    methods: {
        async fetchHornConfig() {
            try {
                const isProd = ['beta', 'staging', 'production'].includes(process.env.NODE_ENV);
                const urlPrefix = '//portal-portm.meituan.com/horn/v1/modules';
                const apiName = isProd ? 'prod' : 'test';
                const url = [urlPrefix, 'vss', apiName].join('/');
                const res = await this.$get(url, {}, { parseData: false });
                this.printLogoMap = res.printLogoMap;
            } catch {
                this.printLogoMap = {};
            }
        },
        // 复用采购单打印的接口
        async getBeforePrintData() {
            try {
                const { skuId, poiId, skuCode } = this.currentRow;
                const resData = await getVssPrintBeforeData({
                    sourceCode: 3,
                    poiId,
                    skuId: +skuId,
                    skuCode,
                    supplierId: this.supplierId,
                    fromPreOrder: true, // 新增 是否为预采
                });
                this.beforePrintData = {
                    ...resData,
                    expiryTimeList: resData.expiryTimeList.map((item) => ({
                        label: item,
                        value: item,
                    })),
                };
                const { expiryTimeList, expiryType } = this.beforePrintData;
                this.isABOrders = resData?.needChainTagId || false;
                if (expiryTimeList?.length) {
                    if (expiryType === ExpirationTypeEnum.HALF_DAY.code) {
                        if (this.planType === PLAN_TYPE.T1) {
                            // 明日预采：默认枚举值为12点
                            this.printForm.printTime = '12:00';
                        } else {
                            // 今日预采：默认枚举值为0点
                            this.printForm.printTime = '00:00';
                        }
                    }
                }
            } catch {
                this.resetBeforePrintData();
            }
        },
        async getSupplierId() {
            const res = await this.__getSupplierInfoByBizAcountId();
            const { supplierId } = res || {};
            this.supplierId = supplierId;
        },
        async fetchProductOrigin() {
            try {
                const { skuId, poiId } = this.currentRow;
                const res = await checkAndQueryProductOrigin({
                    poiId,
                    skuId: +skuId,
                    supplierId: this.supplierId,
                });
                const { originPlaceList, needSelect } = res || {};
                this.originPlaceList = originPlaceList || [];
                this.isShowProduceArea = needSelect;
                this.queryOriginPlaceStatus = true;
            } catch (e) {
                // 提示错误
                this.$message.error(e.message || '获取商品产地失败');
            }
        },
        async initPrintForm() {
            try {
                this.dialogLoading = true;
                this.showPrintDialog = true;
                const { printDate } = this.currentRow;
                this.printForm.printDate = new Date(printDate);
                this.isLimitPrintDate = !!printDate;
                await this.getSupplierId();
                await this.fetchHornConfig();
                await this.getBeforePrintData();
                await this.fetchProductOrigin();
            } catch (error) {
                this.$message.error(error.message || '初始化打印表单失败');
            } finally {
                this.dialogLoading = false;
            }
        },

        initPrinter() {
            MTOBClient.on(ESDKEvents.StatusChange, async (args) => {
                if (args.status === ESDKStatus.READY) {
                    this.$message({
                        message: '打印助手建立连接成功',
                        type: 'success',
                        customClass: 'message-z-index',
                    });
                    try {
                        const list = await MTOBPrinter.getPrinterList();
                        this.printerList = list.map((item) => item.name);
                    } catch (e) {
                        this.$message({
                            message: e.message,
                            type: 'error',
                            customClass: 'message-z-index',
                        });
                    }
                } else if (args.status === ESDKStatus.ERROR) {
                    this.$message.warning(
                        '打印助手建立连接超时或发送消息失败，请确保本地已启动 MTOB 客户端',
                    );
                } else if (args.status === ESDKStatus.DISCONNECTED) {
                    this.$message({
                        message: '打印助手连接断开',
                        type: 'warning',
                        customClass: 'message-z-index',
                    });
                } else if (args.status === ESDKStatus.MTOB_UPDATE_REQUIRED) {
                    this.$message({
                        message: '客户端版本较低，正在自动更新，如果长时间未升级可手动下载打印助手',
                        type: 'warning',
                        customClass: 'message-z-index',
                    });
                }
            });
            MTOBClient.init({
                appName: 'mall-fe-vss',
                env: process.env.NODE_ENV || 'test',
                projectId: 'mall-fe-vss',
            });
        },
        getCustomTemplateUrl(skuPrintData) {
            const {
                attributeList,
                stencilType,
            } = skuPrintData.labelResult;
            let templateUrl;
            if (stencilType === 2) {
                // 2 为自定义标签
                templateUrl = (attributeList || []).find(
                    (element) => element.attributeKey === 'customLabelConfigUrl',
                ).attributeValue;
            }
            return templateUrl;
        },
        formatPrintData(skuPrintData) {
            const [ytType] = skuPrintData.ytType;
            const { printQuantity } = this.printForm;
            const {
                attributeList,
                // 快驴平台模版Id(jsonId)
                templateId,
                // 平台标识：1=快驴平台；2=自建新平台
                templateSource,
                // 新平台模版S3文件地址（templateSource=2时有值）
                s3JsonUrl,
            } = skuPrintData.labelResult;
            const { barCodeList, pcsCode } = skuPrintData.barCodeResult;
            const logo = this.printLogoMap[ytType] || '';
            console.log('logo=>', logo, ytType, this.printLogoMap);
            // 新自建平台的模版也走templateUrl打印，注意兼容自定义标签的逻辑
            // 新自建平台模版Url
            const newTemplateUrl = templateSource === TEMPLATE_SOURCE_ENUM.NEW ? s3JsonUrl : '';
            // 自定义标签的模版Url
            const customTemplateUrl = this.getCustomTemplateUrl(skuPrintData);
            const useCustomTemplate = !isEmptyValue(customTemplateUrl);
            let initialAttributes;
            if (useCustomTemplate) {
                console.log('使用自定义标签');
                initialAttributes = {
                    templateUrl: customTemplateUrl,
                };
            } else if (templateSource === TEMPLATE_SOURCE_ENUM.NEW) {
                console.log('使用新平台模版');
                // 新自建平台模版，走 templateUrl
                if (isEmptyValue(s3JsonUrl)) {
                    throw new Error('模版地址为空，无法打印');
                }
                initialAttributes = {
                    templateUrl: newTemplateUrl,
                    logo,
                };
            } else {
                console.log('使用快驴平台模版');
                // 快驴平台模版，走 templateId
                if (isEmptyValue(templateId)) {
                    throw new Error('模版Id为空，无法打印');
                }
                initialAttributes = {
                    templateId,
                    logo,
                };
            }
            const attributeMap = (attributeList || []).reduce((acc, cur) => {
                const { attributeKey, attributeValue } = cur;
                if (attributeKey !== 'customLabelConfigUrl') {
                    // customLabelConfigUrl 是自定义模板的 url，不需要作为键值对传进去
                    acc[attributeKey] = attributeValue;
                    if (attributeKey === 'hideCode') {
                        acc.extraCode = attributeValue;
                    }
                }
                return acc;
            }, initialAttributes);
            if (pcsCode) {
                return barCodeList.map((v) => ({
                    barCode: v,
                    qrCode: useCustomTemplate ? v : undefined,
                    ...attributeMap,
                }));
            }
            return new Array(+printQuantity).fill({
                barCode: barCodeList[0],
                qrCode: useCustomTemplate ? barCodeList[0] : undefined,
                ...attributeMap,
            });
        },
        resetBeforePrintData() {
            this.beforePrintData = {
                tips: [],
                expiryTimeList: [],
                alertMessage: '',
                expiryType: '',
            };
        },
        async getPrintData() {
            const {
                skuId, skuCode, poiId, planType, prePurchaseDay,
            } = this.currentRow;
            const { printQuantity, chainTagId, produceAreaName } = this.printForm;
            const params = {
                prePlanType: planType,
                prePurchaseDay: moment(prePurchaseDay).valueOf(),
                businessTypeCode: -1,
                deviceTypeCode: 1,
                sourceCode: 3,
                poiId,
                operator: cookie.get('msid'),
                supplierId: this.supplierId,
                fromPreOrder: true,
                needLabelData: true,
                skuPrintParamList: [
                    {
                        skuId,
                        skuCode,
                        genQuantity: printQuantity,
                        productDate: this.formatterDateTime(),
                        newProduceTime: this.formatterNewDateTime(),
                    },
                ],
                chainTagId,
                // 支持新平台模版打印
                selfTemplateSupportFlag: true,
            };
            if (this.isShowProduceArea) {
                params.transmissionParamList = [
                    {
                        attributeValue: produceAreaName,
                        attributeDesc: '产地属性',
                        attributeKey: 'produceAreaName',
                    },
                ];
            }
            const { printResultList } = await getVssPrintData(params);
            return printResultList[0] || {};
        },
        async confimPrintByMtob() {
            if (!this.queryOriginPlaceStatus) {
                this.$message.error('【产地】数据超时获取失败，请关闭弹窗重试');
                return;
            }
            try {
                await this.$refs.printForm.validate();
            } catch (e) {
                this.$message.error(e.message || '请根据错误提示修改');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '打印即将开始，请稍后...',
            });
            try {
                const { printer } = this.printForm;
                const resData = await this.getPrintData();
                const printData = this.formatPrintData(resData);
                try {
                    await MTOBPrinter.print(printData, {
                        printerName: printer,
                        templateId: printData[0].templateId,
                        templateURL: printData[0].templateUrl,
                    });
                    this.$message.success('开始执行打印任务');
                    this.showPrintDialog = false;
                } catch (e) {
                    this.$message.error(`打印失败: ${e.message}`);
                } finally {
                    loading.close();
                }
            } catch (error) {
                this.$message.error(error.message || '打印接口报错');
            } finally {
                loading.close();
                this.$emit('cancel-dialog');
            }
        },
        handleClickDownloadPrintHelper() {
            try {
                const downloadUrl = MTOBClient.getMTOBInfo()
                    .requiredVersionDownloadURL;
                this.$tools.download(
                    downloadUrl
                        || 'https://portal-portm.meituan.com/klfe/mtob/prod/downloadConfig?version=2.1.8',
                );
                // eslint-disable-next-line no-empty
            } catch (e) {}
        },
        onClickCancelDialog() {
            this.showPrintDialog = false;
            this.$emit('cancel-dialog');
        },
        formatterDateTime() {
            const { printDate, printTime } = this.printForm;
            if (this.showHourSelect) {
                let datetime;
                if (printDate && printTime) {
                    const date = moment(printDate).format('YYYY-MM-DD');
                    datetime = new Date(`${date} ${printTime}:00`).getTime();
                } else {
                    datetime = printDate;
                }
                return datetime;
            } else {
                return +moment(printDate)
                    .startOf('day')
                    .format('x');
            }
        },
        formatterNewDateTime() {
            const { printDate, printTime } = this.printForm;

            // 确保 printDate 存在
            if (!printDate) return ''; // 或返回默认值

            if (this.showHourSelect) {
                // 需要时间选择
                if (printDate && printTime) {
                    // 合并日期和时间
                    const datePart = moment(printDate).format('YYYY-MM-DD');
                    return moment(`${datePart} ${printTime}`).format(
                        'YYYY-MM-DD HH:mm',
                    );
                } else {
                    // 只有日期没有时间
                    return moment(printDate).format('YYYY-MM-DD 00:00');
                }
            } else {
                // 不需要时间选择，取当日开始时间
                return moment(printDate)
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.red {
    color: red;
}

.configPrintDialog {
    /deep/ {
        .xx-form-panel .title {
            padding: 0;
        }

        .el-dialog__header {
            height: 0;

            .el-dialog__headerbtn {
                top: 0;
                right: 0;
                font-size: 20px;
            }
        }
    }
}
.dialog-footer {
    display: flex;
    justify-content: center;
}
</style>
<style lang="scss">
.message-z-index {
    z-index: 3000 !important;
}
</style>
